if ($(".global").length) {
  var bookID = "1D0UyELr58cb7PbXyPox2epScfggAl04Ml5bYEImPL1k",
    sheetID = "1290089237",
    qry = encodeURIComponent(
      "SELECT B,C,D,E,F,G,H,I,J WHERE A = TRUE ORDER BY F,E"
    ),
    url =
      "https://docs.google.com/spreadsheets/d/" +
      bookID +
      "/gviz/tq?tqx=out:csv&tq=" +
      qry +
      "&gid=" +
      sheetID,
    $countries = [],
    $locations = null;

  $.ajax({
    type: "GET",
    url: url,
    datatype: "json",
    success: function (data) {
      data = Papa.parse(data, { header: true });
      data = data.data;
      var html = "",
        phone = "";

      $(data).each(function () {
        if ($countries.indexOf(this.Country) === -1) {
          $countries.push(this.Country);
        }
      });
      $countries.sort();
      $countries.unshift("United States");

      $locations = new Array($countries.length);

      $($countries).each(function (i) {
        $locations[i] = new Array();
        //separate out each countries results and put into 2 dimensional array;
        $(data).each(function (j) {
          if (this.Country === $countries[i]) {
            $locations[i].push(this);
          }
        });
        $("#countries").append(
          '<option value="' +
            this +
            '" data-image="https://cdn.shopify.com/s/files/1/1125/0762/files/flag-' +
            handleize(this) +
            '.gif">' +
            this +
            "</option>"
        );
      });
      $(".dropdown select").msDropDown();
    },
  });

  $("#countries").change(function () {
    if ($(this).prop("selectedIndex") == 1) {
      window.location = "/pages/dealer-locator";
    } else {
      var idx = $(this).prop("selectedIndex") - 1;
      if (idx >= 0) {
        $("#results").fadeOut(function () {
          var html = "";
          for (i = 0; i < $locations[idx].length; i++) {
            var name = $locations[idx][i].Retailer,
              address = $locations[idx][i].Address,
              suburb = $locations[idx][i].Suburb,
              state = $locations[idx][i].State,
              postalcode = $locations[idx][i].PostalCode,
              phone = $locations[idx][i].Phone,
              website = $locations[idx][i].Website,
              facebook = $locations[idx][i].Facebook;

            html += '<div class="result-block">';
            html += "<h2>" + name + "</h2>";
            if (address.length > 0) {
              html += "<div>" + address + "</div>";
            }
            if (suburb.length > 0) {
              html +=
                "<div>" + suburb + ", " + state + " " + postalcode + "</div>";
            }
            if (phone.length > 0) {
              html += '<div class="phone">' + phone + "</div>";
            }
            if (website.length > 0) {
              html +=
                '<div><a href="' +
                website +
                '" target="_new" class="website">' +
                website +
                "</a></div>";
            }
            if (facebook.length > 0) {
              html +=
                '<div><a href="' +
                facebook +
                '" target="_new" class="facebook">' +
                facebook +
                "</a></div>";
            }
            html += "</div>";
          }
          $("#results").html(html);
        });
        $("#results").fadeIn();
      }
    }
  });
}

if ($(".locator").length) {
  var locateType = $(".locator").attr("data-locate-type");
  if (locateType == "Sales Rep") {
    var bookID = "1D0UyELr58cb7PbXyPox2epScfggAl04Ml5bYEImPL1k",
      sheetID = "0",
      qry = encodeURIComponent("SELECT B,C,D,E,F WHERE A = TRUE ORDER BY D"),
      url =
        "https://docs.google.com/spreadsheets/d/" +
        bookID +
        "/gviz/tq?tqx=out:csv&tq=" +
        qry +
        "&gid=" +
        sheetID;
  }

  if (locateType == "Dealer") {
    var bookID = "1D0UyELr58cb7PbXyPox2epScfggAl04Ml5bYEImPL1k",
      sheetID = "817019635",
      qry = encodeURIComponent(
        "SELECT B,C,D,E,F,G,H,I,J,K,L,M,N WHERE A = TRUE ORDER BY F,E"
      ),
      url =
        "https://docs.google.com/spreadsheets/d/" +
        bookID +
        "/gviz/tq?tqx=out:csv&tq=" +
        qry +
        "&gid=" +
        sheetID;
  }

  $.ajax({
    type: "GET",
    url: url,
    datatype: "json",
    success: function (data) {
      data = Papa.parse(data, { header: true });
      data = data.data;
      var html = "",
        locationInfo = "",
        phone = "";
      $(data).each(function (index) {
        if (locateType == "Dealer") {
          var aerotac_authorize = "";
          if (
            this.AeroTac_Authorized != "" &&
            this.AeroTac_Authorized == "TRUE"
          ) {
            aerotac_authorize =
              '<li style="color:#AD9855;"><strong>Aero-Tac Authorized</strong></li>';
          }

          var html =
            '<div class="locate-block" data-states="' +
            this.RefState +
            '"><h3><b>' +
            this.Name +
            "</b></h3><ul>";
          if (this.Address != "") {
            html += '<li class="address">' + this.Address + "</li>";
          }
          if (this.Address2 != "") {
            html += '<li class="address">' + this.Address2 + "</li>";
          }
          if (this.Address != "") {
            html +=
              '<li class="address">' +
              this.City +
              ", " +
              this.State +
              " " +
              this.Zip +
              "</li>";
            html += aerotac_authorize + "<br>";
            html +=
              '<li class="phone">' +
              this.Phone.substr(0, 3) +
              "." +
              this.Phone.substr(3, 3) +
              "." +
              this.Phone.substr(6, 4) +
              "</li>";
          }

          if (this.StoreHours != "") {
            html +=
              "<li><strong>Store Hours:</strong> " + this.StoreHours + "</li>";
          }
          html += "<li>";
          if (this.Email != "") {
            html += '<a href="mailto:' + this.Email + '">Email</a>';
          }
          if (this.Website != "") {
            html += this.Email != "" ? " | " : "";
            html += '<a href="' + this.Website + '" target="_new">Website</a>';
          }
          if (this.Facebook != "") {
            html += this.Email != "" || this.Website != "" ? " | " : "";
            html +=
              '<a href="' + this.Facebook + '" target="_new">Facebook</a>';
          }

          html += "</li></ul></div>";

          $("#locatestate .content .col-left").append(html);
        }

        if (locateType == "Sales Rep") {
          phone =
            this.Phone.substr(0, 3) +
            "." +
            this.Phone.substr(3, 3) +
            "." +
            this.Phone.substr(6, 4);
          html =
            '<div class="locate-block" data-states="' +
            this.States +
            '"><h3><b>' +
            this.Name +
            '</b></h3><ul><li class="phone">' +
            phone +
            '</li><li class="maili"><a href="mailto:' +
            this.Email +
            '">' +
            this.Email +
            '</a></li><li class="address">Covers ' +
            this.Coverage +
            "</li></ul></div>";
          $("#locatestate .content .col-left").append(html);
        }
      });
    },
  });

  $("#state-dropdown select").val("");

  $("#state-dropdown select").change(function () {
    var optionSelected = $(this).find("option:selected"),
      code = optionSelected.val(),
      region = optionSelected.text(),
      locateType = $(".locator").attr("data-locate-type"),
      locateCount = 0;

    $("#resultbox").hide();
    $("#no-results").hide();
    $(".locate-block").hide();

    if (!code == "") {
      $("#state-text").text("First Tactical " + locateType + " in " + region);

      $(".locate-block").each(function () {
        var states = $(this).attr("data-states");
        if (states) {
          if (states.indexOf(code.toUpperCase()) >= 0) {
            $(this).show();
            locateCount++;
          }
        }
      });

      if (locateCount == 0) {
        $("#no-results").show();
      }

      $("#resultbox").show();
    }
  });

  $("#popresults").fancybox({
    transitionEffect: "zoom-in-out",
  });
}

function handleize(t) {
  t = t.toLowerCase().replace(" ", "-").replace("& ", "").replace(" ", "-");
  return t;
}
